"use client";

import { Suspense } from "react";
import ReferralSignupForm from "./ReferralSignupForm";

// Wrap the form in Suspense to handle useSearchParams()
export default function ReferralSignupPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ReferralSignupForm />
    </Suspense>
  );
}
